import React from 'react';
import { useSelector } from 'react-redux';
import { ERole } from '../../../shared/enums/user/ERole';
import { RootState } from '../../../store/store';
import EmployeeSkills from '../employeeSkills';
import { EmployeeTable } from './components/EmployeeTable';

const AdminEmployees = () => {
  const { userData } = useSelector((state: RootState) => state.auth);
  const isNormalUser = userData?.role === ERole.USER;

  return (
    <>
      <EmployeeTable />
      {!isNormalUser && <EmployeeSkills />}
    </>
  );
};

export default AdminEmployees;
